var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.question.ansType === 'unknown')?_c('div',{staticClass:"yo-content-block"},[_c('h2',[_vm._v("Choose Answer Type")]),_vm._l((_vm.QS.ansTypes),function(qt){return _c('el-button',{key:qt.name,staticStyle:{"margin":"4px"},style:(qt.style),on:{"click":function($event){return _vm.setAnsType(qt.type)}}},[_vm._v(_vm._s(qt.name))])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }